import React, {useEffect, useState} from "react"
import qs from "qs"
import {withRouter, RouteComponentProps} from "react-router-dom"
import authentication from "@irati/auth"
import Loading from "@irati/ui/src/Loading"
import teamsBotService from "@irati/bots/services/teams"
import {hangPromise} from "@irati/utils/promise"

interface Props extends RouteComponentProps {

}

interface Query {
  state: string,
  redirect: string
}

const TeamsLink: React.FC<Props> = (props) => {
  const [load, setLoad] = useState(hangPromise())
  const query: Query = qs.parse(props.location.search.replace("?", ""))

  useEffect(() => {
    if (authentication.isLoggedIn()) {
      const l = teamsBotService.link(query.state).then(() => {
        window.location.assign(query.redirect)
        return hangPromise()
      })
      setLoad(l)
    }
  }, [])
  return (
    <Loading load={load} />
  )
}

export default withRouter(TeamsLink)
